import React from 'react';
import ContactCard from './ContactCard';

export interface ContactCardProps {
  title: string;
  description: string;
  link: string;
  href: string;
  icon: React.ReactNode;
}

const contactData: ContactCardProps[] = [
  {
    title: 'Chat to sales',
    description: 'Contact with our team',
    link: 'sales@soberhub.com',
    href: 'mailto:sales@soberhub.com',
    icon: (
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" fill="white" />
        <rect
          x="0.5"
          y="0.5"
          width="39"
          height="39"
          rx="19.5"
          stroke="#BFBFBF"
        />
        <path
          d="M19.9993 28.4932V27.2432H25.5762C25.6511 27.2432 25.7125 27.2192 25.7606 27.1711C25.8087 27.1231 25.8327 27.0616 25.8327 26.9868V26.2497H22.8839V20.3522H25.8327V19.1663C25.8327 17.5552 25.2632 16.1802 24.1243 15.0413C22.9855 13.9025 21.6105 13.333 19.9993 13.333C18.3882 13.333 17.0132 13.9025 15.8743 15.0413C14.7355 16.1802 14.166 17.5552 14.166 19.1663V20.3522H17.1148V26.2497H14.4225C14.0015 26.2497 13.6452 26.1038 13.3535 25.8122C13.0618 25.5205 12.916 25.1642 12.916 24.7432V19.1663C12.916 18.192 13.1019 17.2754 13.4737 16.4163C13.8455 15.5573 14.353 14.8063 14.9962 14.1632C15.6393 13.52 16.3903 13.0125 17.2493 12.6407C18.1084 12.2689 19.025 12.083 19.9993 12.083C20.9737 12.083 21.8903 12.2689 22.7493 12.6407C23.6084 13.0125 24.3594 13.52 25.0025 14.1632C25.6457 14.8063 26.1532 15.5573 26.525 16.4163C26.8968 17.2754 27.0827 18.192 27.0827 19.1663V26.9868C27.0827 27.4077 26.9368 27.7641 26.6452 28.0557C26.3535 28.3474 25.9972 28.4932 25.5762 28.4932H19.9993ZM14.4225 24.9997H15.8648V21.6022H14.166V24.7432C14.166 24.8181 14.19 24.8795 14.2381 24.9276C14.2862 24.9756 14.3476 24.9997 14.4225 24.9997ZM24.1339 24.9997H25.8327V21.6022H24.1339V24.9997ZM14.4225 21.6022H14.166H15.8648H14.4225Z"
          fill="#141414"
        />
      </svg>
    ),
  },
  {
    title: 'Chat to support',
    description: 'Contact with our team',
    link: 'support@soberhub.com',
    href: 'mailto:support@soberhub.com',
    icon: (
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" fill="white" />
        <rect
          x="0.5"
          y="0.5"
          width="39"
          height="39"
          rx="19.5"
          stroke="#BFBFBF"
        />
        <path
          d="M19.4879 27.0837V25.8337H25.5775C25.647 25.8337 25.7071 25.8123 25.7579 25.7695C25.8086 25.7269 25.834 25.6708 25.834 25.6014V19.7728C25.834 18.1798 25.264 16.8387 24.124 15.7495C22.9841 14.6603 21.6097 14.1157 20.0007 14.1157C18.3916 14.1157 17.0172 14.6603 15.8773 15.7495C14.7373 16.8387 14.1673 18.1798 14.1673 19.7728V24.6797H13.5423C13.1427 24.6797 12.7998 24.5406 12.5136 24.2624C12.2272 23.9841 12.084 23.6451 12.084 23.2455V21.627C12.084 21.3567 12.1609 21.1091 12.3148 20.8841C12.4687 20.6592 12.6695 20.4785 12.9173 20.3418L12.9559 19.2776C13.0242 18.3705 13.2597 17.5303 13.6625 16.7568C14.0653 15.9833 14.5818 15.31 15.2121 14.7368C15.8425 14.1636 16.5701 13.717 17.3948 13.397C18.2197 13.077 19.0883 12.917 20.0007 12.917C20.913 12.917 21.7795 13.077 22.6 13.397C23.4206 13.717 24.1481 14.1614 24.7827 14.7303C25.4173 15.2992 25.9338 15.9704 26.3323 16.7439C26.7308 17.5175 26.9685 18.3578 27.0454 19.2647L27.084 20.308C27.3265 20.4223 27.526 20.5858 27.6825 20.7985C27.8391 21.0111 27.9173 21.2482 27.9173 21.5099V23.3705C27.9173 23.6322 27.8391 23.8694 27.6825 24.082C27.526 24.2946 27.3265 24.4581 27.084 24.5724V25.6014C27.084 26.0115 26.9368 26.3611 26.6425 26.6501C26.3481 26.9391 25.9931 27.0837 25.5775 27.0837H19.4879ZM17.6609 21.4747C17.4568 21.4747 17.2829 21.4055 17.1392 21.2672C16.9956 21.1289 16.9238 20.9576 16.9238 20.7535C16.9238 20.5494 16.9956 20.3769 17.1392 20.236C17.2829 20.0948 17.4568 20.0243 17.6609 20.0243C17.865 20.0243 18.0389 20.0948 18.1825 20.236C18.3263 20.3769 18.3982 20.5494 18.3982 20.7535C18.3982 20.9576 18.3263 21.1289 18.1825 21.2672C18.0389 21.4055 17.865 21.4747 17.6609 21.4747ZM22.3404 21.4747C22.1363 21.4747 21.9624 21.4055 21.8188 21.2672C21.675 21.1289 21.6032 20.9576 21.6032 20.7535C21.6032 20.5494 21.675 20.3769 21.8188 20.236C21.9624 20.0948 22.1363 20.0243 22.3404 20.0243C22.5445 20.0243 22.7184 20.0948 22.8621 20.236C23.0057 20.3769 23.0775 20.5494 23.0775 20.7535C23.0775 20.9576 23.0057 21.1289 22.8621 21.2672C22.7184 21.4055 22.5445 21.4747 22.3404 21.4747ZM15.31 20.167C15.2235 18.807 15.6466 17.6432 16.5792 16.6757C17.5118 15.7084 18.6662 15.2247 20.0423 15.2247C21.1983 15.2247 22.2183 15.5823 23.1023 16.2976C23.9865 17.0129 24.5231 17.9389 24.7121 19.0755C23.5284 19.0616 22.4346 18.7508 21.4309 18.143C20.4271 17.5351 19.6566 16.7018 19.1192 15.643C18.9077 16.6793 18.4643 17.5954 17.7892 18.3914C17.1139 19.1873 16.2875 19.7792 15.31 20.167Z"
          fill="#141414"
        />
      </svg>
    ),
  },
  {
    title: 'Visit us',
    description: '120 Main St, Springfield	',
    link: 'View on Google',
    href: 'somelocation',
    icon: (
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" fill="white" />
        <rect
          x="0.5"
          y="0.5"
          width="39"
          height="39"
          rx="19.5"
          stroke="#BFBFBF"
        />
        <path
          d="M20.0024 19.8874C20.417 19.8874 20.7714 19.7397 21.0657 19.4445C21.3602 19.1492 21.5074 18.7943 21.5074 18.3797C21.5074 17.9651 21.3598 17.6106 21.0645 17.3161C20.7692 17.0218 20.4142 16.8747 19.9995 16.8747C19.5849 16.8747 19.2305 17.0223 18.9361 17.3176C18.6417 17.6129 18.4945 17.9679 18.4945 18.3826C18.4945 18.7972 18.6421 19.1516 18.9374 19.4459C19.2327 19.7402 19.5877 19.8874 20.0024 19.8874ZM20.0009 26.2609C21.6312 24.8015 22.8788 23.4016 23.7436 22.0613C24.6085 20.7211 25.0409 19.5472 25.0409 18.5397C25.0409 17.0205 24.5583 15.7716 23.593 14.793C22.6277 13.8144 21.4304 13.3251 20.0009 13.3251C18.5715 13.3251 17.3741 13.8144 16.4089 14.793C15.4436 15.7716 14.9609 17.0205 14.9609 18.5397C14.9609 19.5472 15.3934 20.7211 16.2582 22.0613C17.1231 23.4016 18.3707 24.8015 20.0009 26.2609ZM20.0009 27.9243C17.9037 26.107 16.3311 24.4159 15.283 22.8507C14.235 21.2854 13.7109 19.8484 13.7109 18.5397C13.7109 16.6166 14.333 15.0597 15.577 13.869C16.8211 12.6784 18.2958 12.083 20.0009 12.083C21.7061 12.083 23.1807 12.6784 24.4249 13.869C25.6689 15.0597 26.2909 16.6166 26.2909 18.5397C26.2909 19.8484 25.7669 21.2854 24.7189 22.8507C23.6708 24.4159 22.0982 26.107 20.0009 27.9243Z"
          fill="#141414"
        />
      </svg>
    ),
  },
  {
    title: 'Call us',
    description: 'Mon - Fri 9:00 AM - 06:00 PM',
    link: '+1 456 5220 223',
    href: '+1 456 5220 223',
    icon: (
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" fill="white" />
        <rect
          x="0.5"
          y="0.5"
          width="39"
          height="39"
          rx="19.5"
          stroke="#BFBFBF"
        />
        <path
          d="M26.1996 27.0837C24.6291 27.0837 23.0514 26.7185 21.4664 25.9882C19.8816 25.258 18.4254 24.2278 17.0979 22.8978C15.7705 21.5677 14.7417 20.1114 14.0114 18.5291C13.2812 16.9469 12.916 15.3705 12.916 13.8001C12.916 13.5478 12.9993 13.3375 13.166 13.1693C13.3327 13.0011 13.541 12.917 13.791 12.917H16.5089C16.7193 12.917 16.905 12.9857 17.0658 13.123C17.2266 13.2603 17.3289 13.4298 17.3727 13.6318L17.8504 16.0837C17.8834 16.3112 17.8765 16.5066 17.8296 16.6701C17.7825 16.8336 17.698 16.9709 17.5762 17.082L15.6516 18.9555C15.9614 19.5228 16.3153 20.0594 16.7133 20.5653C17.1112 21.0712 17.5421 21.5543 18.0058 22.0147C18.463 22.4721 18.9491 22.8968 19.4641 23.2889C19.9791 23.681 20.5353 24.0458 21.1325 24.3835L23.0025 22.4972C23.1329 22.3615 23.2908 22.2664 23.4762 22.2118C23.6615 22.1573 23.8541 22.144 24.0539 22.1718L26.3679 22.643C26.5783 22.6986 26.75 22.806 26.8831 22.9651C27.0162 23.1243 27.0827 23.3048 27.0827 23.5068V26.2087C27.0827 26.4587 26.9986 26.667 26.8304 26.8337C26.6622 27.0003 26.4519 27.0837 26.1996 27.0837ZM15.0602 17.7728L16.5475 16.3497C16.5741 16.3283 16.5915 16.2989 16.5996 16.2616C16.6076 16.2242 16.6063 16.1895 16.5956 16.1574L16.2333 14.2951C16.2226 14.2525 16.2039 14.2205 16.1773 14.1991C16.1506 14.1777 16.1159 14.167 16.0731 14.167H14.291C14.2589 14.167 14.2322 14.1777 14.2108 14.1991C14.1896 14.2205 14.1789 14.2472 14.1789 14.2793C14.2216 14.8487 14.3148 15.4272 14.4585 16.0147C14.6021 16.6023 14.8027 17.1884 15.0602 17.7728ZM22.3102 24.9747C22.8625 25.2322 23.4387 25.4291 24.0385 25.5653C24.6385 25.7014 25.1991 25.7823 25.7204 25.808C25.7525 25.808 25.7792 25.7973 25.8006 25.776C25.822 25.7546 25.8327 25.7278 25.8327 25.6957V23.9426C25.8327 23.8998 25.822 23.8651 25.8006 23.8385C25.7792 23.8118 25.7472 23.7931 25.7046 23.7824L23.9546 23.4266C23.9225 23.4159 23.8944 23.4146 23.8704 23.4226C23.8464 23.4307 23.8209 23.448 23.7941 23.4747L22.3102 24.9747Z"
          fill="#141414"
        />
      </svg>
    ),
  },
];

const ContactCards: React.FC = () => (
  <div className="mb-4 md:mb-12 px-5 lg:px-0">
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-8">
      {contactData.map((item, index) => (
        <ContactCard key={index} {...item} />
      ))}
    </div>
  </div>
);

export default ContactCards;
